"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import Reveal from "@/components/common/Reveal";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
interface ProcessLinkCopy {
  sentence: string;
  linkLabel: string;
}
const COPY: Record<Lang, ProcessLinkCopy> = {
  en: {
    sentence: "See how woven wire mesh is made, step by step.",
    linkLabel: "Woven wire mesh manufacturing process"
  },
  zh: {
    sentence: "分步了解不锈钢金属编织丝网的完整生产制造全流程。",
    linkLabel: "金属丝网生产流程"
  },
  es: {
    sentence: "Vea cómo se fabrica la malla metálica tejida, paso a paso.",
    linkLabel: "Proceso de fabricación de malla metálica tejida"
  },
  de: {
    sentence: "Erfahren Sie Schritt für Schritt, wie Drahtgewebe hergestellt wird.",
    linkLabel: "Herstellungsprozess von Drahtgewebe"
  },
  fr: {
    sentence: "Découvrez pas à pas les étapes de fabrication de la toile métallique tissée.",
    linkLabel: "Processus de fabrication de toile métallique tissée"
  },
  pt: {
    sentence: "Veja como a malha metálica tecida é fabricada, passo a passo.",
    linkLabel: "Processo de fabricação de malha metálica tecida"
  }
};
export default function ProcessLink() {
  const {
    lang
  } = useLanguage();
  const c = pick(lang, COPY);
  return <section data-nav="light" className="bg-muted/50 text-foreground mf-section-compact border-b border-border">
      <div className="mf-container">
        <Reveal>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm md:text-base">
            <span className="text-foreground/80 font-default">
              {c.sentence}
            </span>
            <Link to="/WovenWireMeshManufacturingProcessPage" className="text-primary hover:underline font-semibold inline-flex items-center gap-1.5 shrink-0">
              <span>{c.linkLabel}</span>
              <ArrowRight className="size-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>;
}